export class FiltroConvite {
    idStatus: number;
    dtInicio: Date;
    dtFim: Date;
}